import type { Home } from '@lmc/ts-common'
import { NavigationModal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Input } from 'antd'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

type DeletingServiceUserModalProps = {
  showModal: boolean
  onCancel: () => void
  onConfirm: () => void
  name: string
  backNavigation: () => void
}

const DeletingServiceUserModal = ({
  showModal,
  onCancel,
  onConfirm,
  name,
  backNavigation
}: DeletingServiceUserModalProps) => {
  const { t } = useTranslation()

  const [inputText, setInputText] = useState('')
  const [matchedInput, setMatchedInput] = useState(false)

  const preferredPeopleNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative
  )

  const handleConfirm = () => {
    onConfirm()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputText(e.target.value)
    setMatchedInput(e.target.value === name)
  }

  return (
    <NavigationModal
      modalTitle={t('DELETE_PROFILE_TITLE')}
      modalConfirmText={t('DELETE_PROFILE')}
      modalCancelText={t('CANCEL')}
      showPrompt={showModal}
      confirmNavigation={handleConfirm}
      cancelNavigation={onCancel}
      confirmButtonProps={{
        variant: matchedInput ? 'danger' : 'default',
        disabled: !matchedInput
      }}
      hasBackButton
      backButtonText={t('BACK')}
      backNavigation={backNavigation}
    >
      <Container>
        <Text>
          <Trans
            i18nKey="DELETE_SU_DESCRIPTION"
            values={{ name }}
            components={{ strong: <strong /> }}
          />
        </Text>
        <Text>
          {t('DELETE_SU_EXTRA', { nominative: preferredPeopleNominative })}
        </Text>
        <Input placeholder={name} value={inputText} onChange={handleChange} />
      </Container>
    </NavigationModal>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 212px;
`

export default DeletingServiceUserModal
